import { nortadaLogger } from '../../../../../../common/logger';
import SuccessOperation from './successOperation';
import { Operation } from './interfaces';
import { DetailsType } from '../../../../../../common/details-list/interface';
import FailureOperation from './failureOperation';
import UnknownOperation from './unknownOperation';

interface Props {
  operation: Operation;
  detailsType: DetailsType;
}

const OperationMetadata = ({ operation, detailsType }: Props) => {
  switch (operation.status) {
    case 'success': {
      return <SuccessOperation operation={operation} detailsType={detailsType} />;
    }
    case 'failure': {
      return <FailureOperation operation={operation} detailsType={detailsType} />;
    }
    case 'unknown': {
      return <UnknownOperation operation={operation} detailsType={detailsType} />;
    }
    default: {
      nortadaLogger.critical(`${operation.status} is not supported operation status`);
      return null;
    }
  }
};

export default OperationMetadata;
